// extracted by mini-css-extract-plugin
module.exports = {"documents":"PolitykaPrywatnosci_documents__sHa08","center":"PolitykaPrywatnosci_center__njSBD"};